/* eslint-disable import/prefer-default-export */
export const SUPPORTED_LANGUAGES = ['en', 'es', 'pt'];
